import apiV2 from "api-v2";
import { FileUploadType } from "newui/components/FileUpload/types/FileUpload.types";
import { FileUploadFile } from "newui/features/Rfx/types/component-types";
import { ApiResponse } from "types/common.types";
import { UploadFile } from "types/storage.types";

export const getMaxFileSizeForReturnableSchedules = (): number | null => {
	const fileSize = parseInt(
		process.env.REACT_APP_MAX_FILE_SIZE_RETURNABLE_SCHEDULE_MB,
		10
	);
	if (!isNaN(fileSize) && fileSize > 0) {
		return fileSize;
	}

	if (fileSize === -1) {
		return;
	}

	return 200;
};

export const deleteFile = (
	fileId: number,
	fileType: FileUploadType,
	filePath: string
): Promise<ApiResponse<void>> => {
	return apiV2.delete(`/file-upload/${fileType}/${fileId}`, {
		params: { filePath: filePath },
	});
};

export const convertToFileUploadFormat = (
	files: UploadFile[]
): FileUploadFile[] => {
	return files
		? files.map((file) => {
				return {
					name: file.file_name,
					path: file.file_path,
					file_size: file.file_size,
					type: file.file_type,
					downloadUrl: file.file_path,
				};
			})
		: [];
};
